const listPointsBody = document.querySelector('#filmAFConsider').querySelector('div[name=body]');
// import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';


const mypopup = document.getElementById("mypopup");



export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index,newMsg , newCmt, countUserReviewer,newVideo) {
    let urlImg = '';
    let groupClass = ' ';
    
    if(item.localgroup == 1)
      groupClass = 'groupsOfConsider_1';
    else  if(item.localgroup == 2)
      groupClass = 'groupsOfConsider_2';
    else  if(item.localgroup == 3)
      groupClass = 'groupsOfConsider_3';


  let newMsgIcon = '';
    if(newMsg)
      newMsgIcon = `<div class = "premiere-icon  popup icon-newMsg"  popupAlert="Новое сообщение от заявителя" ></div>`;
    
    
    let newCmtIcon = '';
    if(newCmt)
      newCmtIcon = `<div class = "premiere-icon  popup icon-newCmt"  popupAlert="Новая заметка" ></div>`;

    let newVideoIcon = '';
    if (newVideo)
      newVideoIcon = `<div class = "premiere-icon  popup icon-newAttach"  popupAlert="Заявитель обновил ссылку!" popupMsg="Shift + click = убрать данное уведомление"  alertNewLinkForfCID=${item.considerID} ></div>`;


    let reviewReady = '';

    if (item.countReview && parseInt(item.countReview, 10) > 0) 
      if(countUserReviewer === parseInt(item.countReview, 10))
        reviewReady = `iconReviewReadyAllBorder `;

  return `<div class = "card_film_preview_only_number column p-1 ${groupClass} ${reviewReady}" fCID=${item.considerID} numReq=${item.numRequest}> 
            <div class="row w-100 m-0 p-0"><little fCID=${item.considerID} numReq=${item.numRequest}>№</little> <div class="lineIcons "> ${newMsgIcon} ${newCmtIcon}  ${newVideoIcon}</div></div>
      
            <h3 class="popup" popupAlert="${item.name}" fCID=${item.considerID}  numReq=${item.numRequest}>${item.numRequest}</h3>
          </div>`;
  },

  drawDataInContainer(enterprisesData,arrNotifications, arrcntUserReviewer, arrNotificationsVideo) {
    this.cleanContainer();
    let HTMLBODY = '';
    if(enterprisesData) {
      listPointsBody.classList.remove('row');
      listPointsBody.classList.remove('column');
      listPointsBody.classList.add('row');
      
      enterprisesData.forEach((item, index) => {


        let newVideo = false;
       
        let newMsg = false;
        let newCmt = false;


        if (arrNotificationsVideo)
          arrNotificationsVideo.forEach((nItem,nIndex) => {
            if (parseInt(item.considerID, 10) === parseInt(nItem.considerID, 10))
              newVideo = true;
          });


        if(arrNotifications)
          arrNotifications.forEach((nItem,nIndex) => {
            if (parseInt(item.considerID, 10) === parseInt(nItem.considerIDNewMessage, 10))
              newMsg = true;
           
            if (parseInt(item.considerID, 10) === parseInt(nItem.considerIDNewComment, 10))
              newCmt = true;
          });

        HTMLBODY += this.getElement(item, index,newMsg, newCmt, arrcntUserReviewer.length, newVideo);
      });
      listPointsBody.innerHTML = HTMLBODY;
    } else
      listPointsBody.innerHTML = 'Данных пока нет';

      let allPopUpListenerClass = listPointsBody.querySelectorAll('.popup');
      allPopUpListenerClass.forEach((buttonItem) => {
        if (buttonItem.attributes.popupAlert) {
          buttonItem.addEventListener("mouseover", (evt) => {
            mypopup.querySelector('b').innerHTML = ''; 
            // mypopup.querySelector('div').style.display = 'block';

            if (evt.target.attributes.popupAlert)
              mypopup.querySelector('b').innerHTML = evt.target.attributes.popupAlert.nodeValue;

            if (evt.target.attributes.popupMsg) {
              mypopup.querySelector('div').style.display = 'block';

              if(evt.target.attributes.popupMsg.nodeValue.length == 19)
                mypopup.querySelector('div').innerHTML = tools.dateStringFullAddTimeZone(evt.target.attributes.popupMsg.nodeValue, curTimeZone);
              else
                  mypopup.querySelector('div').innerHTML = evt.target.attributes.popupMsg.nodeValue;
            }
            else{

              mypopup.querySelector('div').style.display = 'none';
              mypopup.querySelector('div').innerHTML = '';
            }
            

            let iconPos = evt.target.getBoundingClientRect();
            let shift = 0;

            if(evt.target.attributes.popupShift)
              shift = evt.target.attributes.popupShift.nodeValue;

              mypopup.style.left = (iconPos.right - 64 - shift) + "px";


            mypopup.style.top = (window.scrollY + iconPos.top + 30) + "px";
            mypopup.style.display = "block";
          });
          buttonItem.addEventListener("mouseout", ()=> {
            mypopup.style.display = "none";
          });
        }
      });


  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
